export default __webpack_public_path__ + "static/media/AQSPEC_Dashboard.17331529.png";